export default "__VITE_ASSET__CEeOemOl__"